import { TextImageContentModule } from '@silvertours/common-landingpages-view';
import { useMedia } from 'react-use';
import {
  selectBackgroundStyle,
  selectSectionTitleStyle,
  selectLayoutFlow,
  ImageContentBlock,
  PlainContentModuleContainer,
  TextContentBlock,
  WaveContentModuleContainer,
} from '@silvertours/front-entities';
import { Ui, Theme } from '@silvertours/front-shared';

import { getSpacingDirectionFromImagePosition } from '../../particle';

export const TextImage = (props: TextImageContentModule) => {
  const { badge, image, rules = {} } = props;
  const style = rules.style || 'default';
  const imagePosition = rules.imagePosition || 'right';
  const backgroundStyle = selectBackgroundStyle(style);
  const sectionTitleStyle = selectSectionTitleStyle(style);
  const isPlain = !['green', 'mint', 'orange'].includes(style);

  const spacingDirection = getSpacingDirectionFromImagePosition(imagePosition);

  const isMobile = useMedia(
    `(max-width: ${Theme.getBreakpoint('lg')}px)`,
    false,
  );

  const layoutFlow =
    isMobile && (imagePosition === 'right' || imagePosition === 'left')
      ? 'top'
      : selectLayoutFlow(imagePosition);
  const moduleContainerRules = {
    backgroundStyle,
    layoutFlow,
    verticalSpacing: {
      isLarge: !!image,
      spacingDirection,
    },
  };

  const ContentModuleContainer = isPlain
    ? PlainContentModuleContainer
    : WaveContentModuleContainer;

  return (
    <ContentModuleContainer rules={moduleContainerRules}>
      <TextContentBlock
        content={props}
        rules={{
          sectionTitle: {
            shouldHide: imagePosition === 'top',
            style: sectionTitleStyle,
          },
          isContainerMultiColumn: !!image,
          isSecondColumn: imagePosition === 'left',
          textStyle: {
            style: isPlain
              ? Ui.RichTextStyle.Primary
              : Ui.RichTextStyle.Alternative,
          },
          verticalSpacing: {
            isLargeAtXL: image && !isPlain,
            isSmallAtXL: image && isPlain,
          },
        }}
      />
      <ImageContentBlock
        content={props}
        rules={{
          sectionTitle: {
            shouldHide: imagePosition !== 'top',
            style: sectionTitleStyle,
          },
          imagePosition,
          isFirstColumn: imagePosition === 'left',
          verticalAlign: ['left', 'right'].includes(imagePosition)
            ? 'middle'
            : 'top',
          verticalSpacing: {
            isLargeAtLG: badge && !isPlain,
            isNoneAtXL: !isPlain,
          },
        }}
      />
    </ContentModuleContainer>
  );
};
